import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionSection } from './components/SolutionSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { scrollToCompra } from './utils/scroll';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  // Meta Pixel
  useEffect(() => {
    const PIXEL_ID = '1858642644845675';
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
      // noscript fallback pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 800) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen font-sans text-[#111111] bg-white selection:bg-[#C4A7E7] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />

      <FooterSection data-id="element-10" />

      <SocialProofPopup data-id="element-11" />

      <AnimatePresence data-id="element-12">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.1)] z-40 md:hidden" data-id="element-13">
            <button onClick={scrollToCompra} className="w-full bg-[#22C55E] hover:bg-[#16a34a] text-white font-bold py-4 px-4 rounded-full shadow-lg flex items-center justify-center gap-2" data-id="element-14">
              ✅ QUIERO EL MEGA KIT HOY
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}